import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import api from '../../utils/api';
import { FiCalendar, FiGift } from 'react-icons/fi';

function BirthdayAnniversary() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await api.get('/api/birthday-anniversary/events');
      setEvents(response.data.events || []);
    } catch (error) {
      console.error('Failed to fetch events:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[400px]">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header Section */}
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-1">Birthday & Anniversary Events</h1>
          <p className="text-sm text-gray-600">View upcoming birthdays and anniversaries</p>
        </div>

        {events.length === 0 ? (
          <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-16 text-center">
            <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <FiGift className="text-4xl text-gray-400" />
            </div>
            <p className="text-gray-700 text-xl font-semibold mb-2">No upcoming events</p>
            <p className="text-gray-500 text-sm">Birthdays and anniversaries will appear here</p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {events.map((event) => (
              <div key={event.id} className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 hover:shadow-lg transition-all hover:scale-[1.02] duration-200">
                <div className="flex items-start gap-3 mb-3">
                  <div className={`rounded-lg p-2.5 flex-shrink-0 ${
                    event.event_type === 'birthday' 
                      ? 'bg-pink-100' 
                      : 'bg-purple-100'
                  }`}>
                    {event.event_type === 'birthday' ? (
                      <FiGift className={`text-xl ${
                        event.event_type === 'birthday' ? 'text-pink-600' : 'text-purple-600'
                      }`} />
                    ) : (
                      <FiCalendar className={`text-xl ${
                        event.event_type === 'birthday' ? 'text-pink-600' : 'text-purple-600'
                      }`} />
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-gray-900 mb-1">{event.guest_name}</h3>
                    <span className={`inline-block px-2 py-0.5 rounded text-xs font-semibold ${
                      event.event_type === 'birthday' 
                        ? 'bg-pink-100 text-pink-800' 
                        : 'bg-purple-100 text-purple-800'
                    }`}>
                      {event.event_type === 'birthday' ? 'Birthday' : 'Anniversary'}
                    </span>
                  </div>
                </div>
                
                <div className="space-y-2 pt-2 border-t border-gray-100">
                  <div className="flex items-center gap-2 text-sm text-gray-600">
                    <FiCalendar className="text-gray-400 text-base" />
                    <span>{new Date(event.event_date).toLocaleDateString('en-US', { 
                      month: 'long', 
                      day: 'numeric', 
                      year: 'numeric' 
                    })}</span>
                  </div>
                  
                  {event.offer_discount > 0 && (
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-green-600">
                        {event.offer_discount}% Discount Offer
                      </span>
                    </div>
                  )}
                  
                  <div className="flex items-center gap-2">
                    <span className={`text-xs font-medium px-2 py-1 rounded ${
                      event.notification_sent 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {event.notification_sent ? 'Notification sent' : 'Notification pending'}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default BirthdayAnniversary;




